/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { AVM1Object } from '../runtime/AVM1Object';
import { warning } from '@awayfl/swf-loader';
import { wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1MovieClip } from './AVM1MovieClip';
import { WaveAudio, AssetLibrary, Loader, AssetEvent, LoaderEvent, URLLoaderEvent, URLRequest, WaveAudioParser, AudioManager } from '@awayjs/core';
import { MovieClip } from '@awayjs/scene';
var AVM1Sound = /** @class */ (function (_super) {
    __extends(AVM1Sound, _super);
    function AVM1Sound() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Sound.createAVM1Class = function (context) {
        return wrapAVM1NativeClass(context, true, AVM1Sound, [], ['attachSound', 'duration#', 'getBytesLoaded', 'getBytesTotal', 'loadSound',
            'getPan', 'setPan', 'getTransform', 'setTransform', 'getVolume', 'setVolume',
            'start', 'stop', 'onSoundComplete'], null, AVM1Sound.prototype.avm1Constructor);
    };
    AVM1Sound.prototype.avm1Constructor = function (target_mc) {
        this._target = this.context.resolveTarget(target_mc);
        this._sound = null;
        this._playAfterLoading = false;
        this._assetNameSpace = AVM1MovieClip.currentMCAssetNameSpace;
        this._soundCompleteInternal = this._soundCompleteInternal.bind(this);
    };
    AVM1Sound.prototype.alPut = function (p, v) {
        _super.prototype.alPut.call(this, p, v);
        if (p && p.toLowerCase() == 'onsoundcomplete') {
            this.onSoundComplete(v);
        }
    };
    AVM1Sound.prototype.alDeleteProperty = function (p) {
        _super.prototype.alDeleteProperty.call(this, p);
        if (p && p.toLowerCase() == 'onsoundcomplete') {
            this.onSoundComplete();
        }
        return true;
    };
    AVM1Sound.prototype.attachSound = function (linkageID) {
        if (typeof linkageID !== 'string')
            return;
        this._sound = AssetLibrary.getAsset(linkageID, this._assetNameSpace);
        if (!this._sound) {
            warning('AVM1Sound.attachSound no WaveAudio found ' + linkageID);
            return;
        }
    };
    AVM1Sound.prototype.onSoundComplete = function (callback) {
        var _this = this;
        if (callback === void 0) { callback = null; }
        this._onSoundCompleteInternal = callback ? function () { return callback.alCall(_this); } : null;
    };
    AVM1Sound.prototype.loadSound = function (url, isStreaming) {
        var _this = this;
        if (isStreaming) {
            this._playAfterLoading = true;
            console.warn('[AVM1Sound] - loadSound called with isStreaming=true, but streaming not implemented yet', url, isStreaming);
        }
        else {
            this._playAfterLoading = false;
        }
        var loader = new Loader();
        var onAssetCompleteDelegate = function (event) { return _this.onAssetComplete(event); };
        var onLoadCompleteDelegate = function (event) { return _this.onLoadComplete(event); };
        var onLoadErrorDelegate = function (event) { return _this.onLoadError(event); };
        loader.addEventListener(AssetEvent.ASSET_COMPLETE, onAssetCompleteDelegate);
        loader.addEventListener(LoaderEvent.LOADER_COMPLETE, onLoadCompleteDelegate);
        loader.addEventListener(URLLoaderEvent.LOAD_ERROR, onLoadErrorDelegate);
        loader.load(new URLRequest(url), null, url, new WaveAudioParser());
    };
    AVM1Sound.prototype.onAssetComplete = function (event) {
        var asset = event.asset;
        if (asset.isAsset(WaveAudio)) {
            this._sound = asset;
            if (this._playAfterLoading)
                this._sound.play(0);
        }
    };
    AVM1Sound.prototype.onLoadComplete = function (event) {
        if (!this._sound) {
            console.warn('[AVM1Sound] - loadSound: Soundloading is complete, but no WaveAudio was created.');
        }
        /*if(this._loadCallback){
            this._loadCallback();
        }*/
    };
    AVM1Sound.prototype.onLoadError = function (event) {
        console.warn('[AVM1Sound] - loadSound: onLoadError');
        /*if(this._errorCallback){
            this._errorCallback();
        }*/
    };
    AVM1Sound.prototype.getBytesLoaded = function () {
        console.warn('AVM1Sound.getBytesLoaded');
        return 0;
    };
    AVM1Sound.prototype.getBytesTotal = function () {
        console.warn('AVM1Sound.getBytesTotal');
        return 1;
    };
    AVM1Sound.prototype.getDuration = function () {
        console.warn('AVM1Sound.getDuration');
        return 0;
    };
    AVM1Sound.prototype.getPan = function () {
        // console.warn('AVM1Sound.getPan');
        // todo 80pro var transform: ASObject =(<ASObject> this._channel && this._channel.soundTransform);
        return 0; //transform ? transform.axGetPublicProperty('pan') * 100 : 0;
    };
    AVM1Sound.prototype.setPan = function (value) {
        // console.warn("AVM1Sound.setPan");
        // todo 80pro
        /*
        var transform: ASObject = this._channel && this._channel.soundTransform;
        if (transform) {
            transform.axSetPublicProperty('pan', value / 100);
            this._channel.soundTransform = <SoundTransform>transform;
        }
        */
    };
    AVM1Sound.prototype.getTransform = function () {
        console.warn('AVM1Sound.getTransform');
        return null;
    };
    AVM1Sound.prototype.setTransform = function (transformObject) {
        console.warn('AVM1Sound.setTransform');
    };
    AVM1Sound.prototype.getVolume = function () {
        if (this._sound)
            return this._sound.volume * 100;
        if (this._target && this._target.adaptee)
            return this._target.adaptee.soundVolume * 100;
        console.warn('AVM1Sound.getVolume called, but no Sound object attached or target mc set');
        return 100;
    };
    AVM1Sound.prototype.setVolume = function (value) {
        if (isNaN(value)) {
            value = 0;
        }
        if (!this._sound && (!this._target || this._target.adaptee.isAVMScene)) {
            //global volume control
            AudioManager.setVolume(value / 100);
            return;
        }
        if (this._target && this._target.adaptee)
            this._target.adaptee.soundVolume = value / 100;
        if (this._sound)
            this._sound.volume = value / 100;
    };
    AVM1Sound.prototype.start = function (secondOffset, loops) {
        if (!this._sound) {
            warning('AVM1Sound.start called, but no WaveAudio set');
            return;
        }
        secondOffset = isNaN(secondOffset) || secondOffset < 0 ? 0 : +secondOffset;
        loops = isNaN(loops) || loops < 1 ? 1 : Math.floor(loops);
        if (this._target && this._target.adaptee) {
            this._target.adaptee.startSound(this._sound, loops, this._soundCompleteInternal);
        }
    };
    AVM1Sound.prototype.stop = function (linkageID) {
        var sound = linkageID ? AssetLibrary.getAsset(linkageID, this._assetNameSpace) : this._sound;
        if (this._target && this._target.adaptee)
            this._target.adaptee.stopSounds(sound);
        else
            MovieClip.stopSounds(sound);
    };
    AVM1Sound.prototype._soundCompleteInternal = function () {
        //separate soundCompleteInternal function in case onSoundComplete is set after sound is started
        this._onSoundCompleteInternal && this._onSoundCompleteInternal();
    };
    return AVM1Sound;
}(AVM1Object));
export { AVM1Sound };
